module.exports = __webpack_public_path__ + "img/2022.cf8f0088.svg";